import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SendIcon from "@mui/icons-material/Send";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { fontWeights } from "et3-ui-library";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";
import getKhattabatBulkMessagingStore from "../../../../stores/khattabat-stores/messaging-stores/bulk-messaging-store";
import getKhattabatSelectsStore from "../../../../stores/khattabat-stores/selects-store";

const KhattabatBulkMessages = withLiteObserverAndTheme<{
  conversationType: "101C" | "101M";
}>((props) => {
  const { conversationType } = props;
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();
  const selectedCount = getKhattabatSelectsStore().selectedCount.get();
  const {
    isOpenedBulkMessagesBox,
    toggleIsOpenedBox,
    fieldsInput,
    fieldIndexes,
    setFieldInput,
    shouldSendMessages,
    isSendingMessages,
    sendAllMessages
  } = getKhattabatBulkMessagingStore();

  return isAiKhattaba ? null : (
    <Accordion
      expanded={isOpenedBulkMessagesBox.get()}
      onChange={toggleIsOpenedBox}
      variant="outlined"
      disableGutters
      sx={{ borderRadius: 3, "&:before": { display: "none" } }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography fontWeight={fontWeights.semibold}>
          {i18n.get("BULK_MESSAGES_BOX")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={1.5}>
          {fieldIndexes.get().map((index) => (
            <TextField
              key={index}
              size="small"
              fullWidth
              value={fieldsInput.get(index) ?? ""}
              placeholder={i18n.get("KHATTABAT_MESSAGE_PLACEHOLDER")}
              onChange={({ target }) =>
                setFieldInput({ index, text: target.value })
              }
            />
          ))}
          <Typography variant="body2" color="text.secondary" textAlign="center">
            {i18n.getWithExtraData(
              i18n.get("KHATTABAT_BULK_SENDS_TO"),
              `${selectedCount}`
            )}
          </Typography>
          <Button
            variant="contained"
            endIcon={<SendIcon />}
            disabled={!shouldSendMessages.get()}
            onClick={() => sendAllMessages(conversationType)}
            sx={{ alignSelf: "center" }}
          >
            {isSendingMessages.get() ? i18n.get("SENDING") : i18n.get("SEND")}
          </Button>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
});

export default KhattabatBulkMessages;
